import Batch from './batch'

const batch = new Batch()
batch.init()
